/**
 * intl-tel-input のユーティリティを初期化
 * isValidNumber() などのバリデーション機能に必要
 */
export const initIntlTelInput = async (): Promise<void> => {
    try {
        const intlTelInputUtilities = await import('intl-tel-input/utils');
        window.intlTelInputUtils = intlTelInputUtilities;
    } catch {
        // ユーティリティの読み込みに失敗してもアプリは動作する（バリデーションのみ無効）
    }
};
